// extracted by mini-css-extract-plugin
export var elevatedFrame = "_3-2";
export var elevatedShell = "_3-1";
export var shell = "_3-0";